import useInterval from '_reacts/useInterval';
import GenericTemplate from '_templates/GenericTemplate';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {MainPanel} from './MainPanel';
import {SearchPanel} from './SearchPanel';
import {SearchConditions} from './types';

export const RELOAD_TIME = 30000;

export const InspectionProgressMonitorPage = () => {
  const {t} = useTranslation();

  // 確定条件
  const [fixSearchConditions, setFixSearchConditions] = useState<SearchConditions | null>(null);

  const [delay, setDelay] = useState<number | null>(null);

  /**
   * 検索処理
   */
  const handleSearch = useCallback((searchConditions: SearchConditions) => {
    //検索条件FIX
    setFixSearchConditions({...searchConditions}); //同じ条件で再検索できるように新しいオブジェクトにして入れる
    setDelay(RELOAD_TIME);
  }, []);

  /**
   * 再検索処理
   */
  const executeSearch = useCallback(() => {
    if (fixSearchConditions) {
      setFixSearchConditions({...fixSearchConditions});
    }
  }, [fixSearchConditions]);

  useInterval(executeSearch, delay);

  return (
    <GenericTemplate title={t('menu.page_name.検査進捗モニタ')}>
      <SearchPanel onSearch={handleSearch} setDelay={setDelay} />
      <MainPanel searchConditions={fixSearchConditions} setDelay={setDelay} />
    </GenericTemplate>
  );
};
